import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./landingPageTable.module.scss";
import Link from "next/link";

const Wrapper = (
  props: PropsWithChildren<{ className?: string }>,
): ReactElement => {
  return (
    <div className={classNames(styles.wrapper, props.className)}>
      {props.children}
    </div>
  );
};

const Body = (
  props: PropsWithChildren<{
    striped?: boolean;
    className?: string;
  }>,
): ReactElement => {
  return (
    <table
      className={classNames(
        styles.tableBody,
        styles[props.striped ? "striped" : ""],
        props.className,
      )}
    >
      <tbody>{props.children}</tbody>
    </table>
  );
};

const Row = (
  props: PropsWithChildren<{ className?: string }>,
): ReactElement => {
  return (
    <tr className={classNames(styles.tableRow, props.className)}>
      {props.children}
    </tr>
  );
};

const HeaderCell = (
  props: PropsWithChildren<{ style?: any; className?: string }>,
): ReactElement => {
  return (
    <th
      className={classNames(styles.headerCell, props.className)}
      style={props.style}
    >
      {props.children}
    </th>
  );
};

const Cell = (
  props: PropsWithChildren<{ className?: string }>,
): ReactElement => {
  return (
    <td className={classNames(styles.tableCell, props.className)}>
      {props.children}
    </td>
  );
};

const TwoLevelText = (props: {
  label1?: string;
  label2?: string;
  className?: string;
}): ReactElement => {
  return (
    <div className={classNames(styles.twoLevelText, props.className)}>
      {props.label1 && <p className={styles.label1}>{props.label1}</p>}
      {props.label2 && <p className={styles.label2}>{props.label2}</p>}
    </div>
  );
};

const FooterCell = (
  props: PropsWithChildren<{ className?: string }>,
): ReactElement => {
  return (
    <td className={classNames(styles.footerCell, props.className)}>
      {props.children}
    </td>
  );
};

const FooterCta = (props: {
  href: string;
  theme: string;
  label: string;
  target?: string;
  className?: string;
  onClick?: () => void;
}): ReactElement => {
  return (
    <Link
      href={props.href}
      className={classNames(
        styles.footerCta,
        styles[props.theme],
        props.className,
      )}
      onClick={props.onClick}
    >
      {props.label}
    </Link>
  );
};

export const LandingPageTable = {
  Wrapper,
  Body,
  Row,
  HeaderCell,
  Cell,
  FooterCell,
  TwoLevelText,
  FooterCta,
};
